/**
 * matchExplanationHelpers.js — RC 1.28.
 *
 * Tiny pure helpers shared with the popover component. Kept in its
 * own module so unit tests can import without pulling the shadcn
 * alias tree (`@/components/ui/popover`) that CRA's jest resolver
 * doesn't understand.
 */

export function humaniseStrictness(s) {
  if (s === 'strict') return 'Strict';
  if (s === 'open')   return 'Open';
  return 'Balanced';
}

export function humaniseRelocation(r) {
  if (r === 'yes') return 'Open to relocation';
  if (r === 'no')  return 'Not open to relocation';
  return 'Open conditionally';
}

export function shouldRenderExplanation(preferenceScoring) {
  return Boolean(preferenceScoring && preferenceScoring.explanation);
}
